import { AxiosInstance } from 'axios';

import { LocationAddresses, PropertyDetail, UserDetails, YourDetails } from '@/types';

export class UsersService {
  private usersAgent: AxiosInstance;
  constructor(usersAgent: AxiosInstance) {
    this.usersAgent = usersAgent;
  }

  public getUserDetailsNew = async (email: string) => {
    const result = await this.usersAgent.get<UserDetails>('/user-details/getUserDetailsNew', {
      params: {
        email,
      },
    });

    return result.data;
  };

  public getCustomer = async (auth0Token: string) => {
    const { data } = await this.usersAgent.get(`/my-account/customer`, {
      headers: {
        Authorization: `Bearer ${auth0Token}`,
      },
    });
    return data;
  };

  public getAbandonedCart = async (email: string) => {
    const result = await this.usersAgent.get('/user-details/getAbandonedCart', {
      params: {
        email,
      },
    });
    return result.data;
  };

  public postAbandonedCart = async (
    orderDetails: any,
    formData: any,
    email: string,
    customerDetails?: YourDetails,
    propertyDetails?: PropertyDetail,
    couponDetails?: any,
    boxDetails?: any
  ) => {
    let payload: any = {
      orderDetails,
      formData,
      email,
      customerDetails: customerDetails ? customerDetails : {},
      propertyDetails: propertyDetails ? propertyDetails : {},
      couponDetails,
      boxDetails,
    };
    return (await this.usersAgent.post('/cart/abandonedCart', payload))?.data;
  };

  public getLocationIdFromTui = async (tui: string) => {
    let locationData = (await this.usersAgent.get<LocationAddresses>(`/location?tui=${tui}`)).data;
    if (locationData?.addresses?.length > 0) {
      return locationData.addresses[0];
    }
    return null;
  };
  // public postAbandonedCart = async (
  //   email: string,
  //   orderDetails: T_Order | undefined,
  //   boxDetails: Box[],
  //   couponDetails?: T_Coupon[],
  //   customerDetails?: YourDetails,
  //   propertyDetails?: PropertyDetail,
  //   //addressId?:AddressData,
  //   addressData?: any,
  //   jounery?: string
  // ) => {
  //   let payload: any = {
  //     email: email ? email : '',
  //     orderDetails: orderDetails,
  //     boxDetails: boxDetails ? boxDetails : [],
  //     couponDetails: couponDetails ? couponDetails : [],
  //     customerDetails: customerDetails ? customerDetails : {},
  //     propertyDetails: propertyDetails ? propertyDetails : {},
  //     addressData: addressData ? addressData : {},
  //     jounery: jounery,
  //   };

  //   return (await this.orderAgent.post<abandonedCartResponse>('/cart/abandonedCart', payload)).data;
  // };
}
